import { type FetchVoteTokenByVoteTokenIdParams, voteTokenApi } from '@capsicum/common';

export async function fetchVoteTokenByVoteToken(params: FetchVoteTokenByVoteTokenIdParams) {
	return (await voteTokenApi)
		.fetchVoteTokenByVoteTokenId({
			...params
		})
		.then(res => res.data);
}
